import { lazy, Suspense, useEffect } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { object, string } from 'prop-types';
import { MainLayout } from 'src/components/layout/MainLayout';
import { ErrorPage } from 'src/components/pages/error/ErrorPage';
import { SmartRoute } from 'src/components/common/smartComponents';
import { tracker } from 'src/utils/trackingHelper';
import { isOnboardingTemporarilyDisabled } from 'src/utils/capabilities';
import { ssoRedirect } from 'src/utils/ssoRedirect';
import {
  INTERNAL_LOGIN_PAGE_URL,
  LOGIN_PAGE_URL,
} from 'src/constants/urlConstants';
import { LoaderComponent } from 'src/components/common/Loader';
import { retryImport } from 'src/utils/retryImport';

const Dashboard = lazy(() =>
  retryImport(() => import('src/components/pages/dashboard')),
);
const Accounts = lazy(() =>
  retryImport(() => import('src/components/pages/accounts')),
);
const MyAgency = lazy(() =>
  retryImport(() => import('src/components/pages/myAgency')),
);
const Onboarding = lazy(() =>
  retryImport(() => import('src/components/pages/onboarding')),
);
const Compliance = lazy(() =>
  retryImport(() => import('src/components/pages/compliance')),
);
const EditAgencyLayout = lazy(() =>
  retryImport(() =>
    import('src/components/pages/myAgency/editAgency/EditAgencyLayout'),
  ),
);

const Routes = props => {
  useEffect(() => {
    tracker.page();

    if (
      props.location.pathname === INTERNAL_LOGIN_PAGE_URL ||
      props.location.pathname === LOGIN_PAGE_URL
    ) {
      ssoRedirect.login({
        internal: props.location.pathname === INTERNAL_LOGIN_PAGE_URL,
      });
    }
  }, [props.location.pathname]);

  return (
    <MainLayout {...props}>
      <Suspense fallback={<LoaderComponent />}>
        <Switch>
          <Route exact path="/">
            <Redirect to="/quick-links" />
          </Route>
          <SmartRoute component={Dashboard} path="/quick-links" />
          <Route path="/onboarding">
            {isOnboardingTemporarilyDisabled ? (
              <Redirect to="/410" />
            ) : (
              <Route component={Onboarding} path="/onboarding" />
            )}
          </Route>
          <SmartRoute component={Compliance} path="/my-agency/compliance" />
          <SmartRoute component={EditAgencyLayout} path="/my-agency/edit" />
          <SmartRoute component={MyAgency} path="/my-agency" />
          <SmartRoute component={Accounts} path="/outstanding-quotes" />
          <SmartRoute component={Accounts} path="/recent-submissions" />
          <SmartRoute component={Accounts} path="/prospects" />
          <SmartRoute component={Accounts} path="/opportunities" />
          <Route component={ErrorPage} path="*" />
        </Switch>
      </Suspense>
    </MainLayout>
  );
};

Routes.propTypes = {
  location: object,
  pathname: string,
};

export default Routes;
